import { categories } from '@/mocks/categories';

export default function Footer() {
  const mainCategories = categories.slice(0, 8);
  const moreCategories = categories.slice(8);

  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-2/5">
            <a href="/" className="text-foreground-950 font-heading text-2xl font-bold tracking-tight">
              oopbuy.surf
            </a>
            <p className="mt-4 text-foreground-600 text-sm leading-relaxed max-w-sm">
              The ultimate OOPBuy Spreadsheet guide and product sourcing hub. Browse curated categories, discover trending items, and shop smarter with organized product lists.
            </p>
            <div className="mt-6">
              <a
                href="/article/what-is-oopbuy-spreadsheet"
                className="inline-flex items-center gap-2 text-accent-700 hover:text-accent-800 text-sm font-medium transition-colors duration-200 cursor-pointer"
              >
                Read the Full OOPBuy Spreadsheet Guide
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-8 lg:w-3/5">
            <div>
              <h4 className="text-foreground-950 font-heading text-base font-semibold mb-4">
                Top Categories
              </h4>
              <ul className="space-y-2.5">
                {mainCategories.map((cat) => (
                  <li key={cat.id}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-foreground-600 hover:text-foreground-950 text-sm transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-foreground-950 font-heading text-base font-semibold mb-4">
                More Categories
              </h4>
              <ul className="space-y-2.5">
                {moreCategories.map((cat) => (
                  <li key={cat.id}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-foreground-600 hover:text-foreground-950 text-sm transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-foreground-950 font-heading text-base font-semibold mb-4">
                Resources
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <a
                    href="/article/what-is-oopbuy-spreadsheet"
                    className="text-foreground-600 hover:text-foreground-950 text-sm transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    OOPBuy Spreadsheet Guide
                  </a>
                </li>
                <li>
                  <a
                    href="https://kaspreadsheet.com/"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-foreground-600 hover:text-foreground-950 text-sm transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    Main Platform
                  </a>
                </li>
                <li>
                  <a
                    href="/#faq"
                    className="text-foreground-600 hover:text-foreground-950 text-sm transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    FAQ
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; 2026 oopbuy.surf — OOPBuy Spreadsheet Guide. All rights reserved.
          </p>
          <p className="text-foreground-400 text-xs">
            External links open on kaspreadsheet.com
          </p>
        </div>
      </div>
    </footer>
  );
}